import {
  RewardsHistoryByRuleCell,
  RewardsHistoryColumn,
} from '../models/rewards-v2.models';
import { formatRewardsUsd, REWARDS_ZERO_DISPLAY } from './rewards-currency.util';

export interface RewardsTableByRuleRow {
  total_rewards: number;
  by_rule: Record<string, RewardsHistoryByRuleCell>;
}

export function formatRewardsTableCurrency(amount: number | string): string {
  return formatRewardsUsd(amount, { zeroDisplay: REWARDS_ZERO_DISPLAY });
}

export function getRuleCount(row: RewardsTableByRuleRow, ruleId: string): string {
  const count = row.by_rule?.[ruleId]?.count ?? 0;
  return count === 0 ? REWARDS_ZERO_DISPLAY : String(count);
}

export function getRuleAmount(row: RewardsTableByRuleRow, ruleId: string): string {
  const amount = row.by_rule?.[ruleId]?.amount ?? 0;
  return formatRewardsTableCurrency(amount);
}

export function ruleCountColumnHeader(column: RewardsHistoryColumn): string {
  return column.name;
}

export function ruleAmountColumnHeader(column: RewardsHistoryColumn): string {
  return `${column.name} Rewards`;
}
